import { FontAwesome } from "@expo/vector-icons";
import { EventNoticeDetails } from "features/types";
import React from "react";

interface EventNoticeIconProps {
  type: EventNoticeDetails["type"];
  size: number;
}

const eventNoticeConfig = {
  icon: {
    HEALTH: "plus",
    INFO: "info",
    PROMO: "star",
    PREMIUM: "usd",
  },
  color: {
    HEALTH: "red",
    INFO: "rgb(23, 162, 184)",
    PROMO: "rgb(255, 193, 7)",
    PREMIUM: "rgb(144, 202, 249)",
  },
};
const EventNoticeIcon: React.FC<EventNoticeIconProps> = ({ type, size }) => {
  const iconName = eventNoticeConfig.icon[
    type
  ] as keyof typeof FontAwesome.glyphMap;
  const iconColor = eventNoticeConfig.color[type];
  return (
    <FontAwesome name={iconName} color={iconColor} size={size}></FontAwesome>
  );
};

export default EventNoticeIcon;
